import { render, staticRenderFns } from "./UserConnectWalletTable.vue?vue&type=template&id=0e134ddc&scoped=true"
import script from "./UserConnectWalletTable.vue?vue&type=script&lang=js"
export * from "./UserConnectWalletTable.vue?vue&type=script&lang=js"
import style0 from "./UserConnectWalletTable.vue?vue&type=style&index=0&id=0e134ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e134ddc",
  null
  
)

export default component.exports